<template>
  <validation-observer ref="observer" v-slot="{ invalid }">
    <v-card class="pb-4" outlined>
      <v-card-title class="py-1" :style="{ 'background-color': '#eeeeee' }">
        {{ $t('MSG0080') }}
      </v-card-title>
      <v-card-text class="py-1">
        <v-container class="form-mmmm-epson px-2 py-2" fluid>
          <v-form :disabled="!canEditContents">
            <v-row class="my-0">
              <v-col>
                <v-card elevation="1" max-width="1200" outlined>
                  <v-card-title class="py-0">
                    {{ $t('ELE0485') }}
                  </v-card-title>
                  <v-card-text class="py-4">
                    <v-row>
                      <v-col>
                        <TextFieldInput :label="$t('ELE0476')" v-model="form.plPr.moldAssetNo" :maxLength="50" />
                      </v-col>
                      <v-col>
                        <TextFieldInput :label="$t('ELE0477')" v-model="form.plPr.mcsRegistrationNo" :maxLength="50" />
                      </v-col>
                      <v-col>
                        <FileInput
                          :label="$t('ELE0478')"
                          v-model="mcsRegistrationFile"
                          :filePath.sync="form.plPr.mcsRegistrationFilePath"
                          :clearable="canEditContents"
                        />
                      </v-col>
                      <v-col> </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-row class="my-0">
              <v-col>
                <v-card class="pb-2" elevation="1" max-width="1200px" outlined>
                  <v-card-title class="py-1">
                    {{ $t('ELE0480') }}
                  </v-card-title>
                  <v-card-text class="py-4">
                    <v-row>
                      <v-col cols="4">
                        <MmmmInspIndexInput
                          v-if="canEditContents && form.sampleAttachedQty > 0"
                          :label="$t('ELE0479')"
                          v-model="form.iqcInspIndexNo"
                          :inspTimingCd="enumOqcIqcCd.IQC"
                          :manufacturerCd="form.manufacturerCd"
                          :partCd="form.partCd"
                          :lotNo="form.lotNo"
                          :inspStatusCd="enumInspStatusCd.COMPLETE"
                          required
                        />
                        <TextFieldRef v-else :label="$t('ELE0479')" :value="form.iqcInspIndexNo" />
                      </v-col>
                      <v-col>
                        <Btn
                          :label="$t('ELE0307')"
                          :disabled="!isEpson || form.iqcInspIndexNo == ''"
                          @click="showInspResult"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="d-flex justify-end">
                        <BtnAdd :disabled="!canEditContents" @click="onAddEvaluation" />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-card class="mx-2" outlined>
                          <v-data-table
                            :headers="headersEvaluation"
                            :items="evaluations"
                            dense
                            disable-pagination
                            hide-default-footer
                            mobile-breakpoint="0"
                          >
                            <template v-slot:[`item.action`]="{ item, index }">
                              <IconDelete
                                :disabled="!canEditContents || item.evaluationCd != ''"
                                @click="onDeleteEvaluation(index)"
                              />
                            </template>
                            <template v-slot:[`item.evaluationName`]="{ item, index }">
                              <TextFieldInput
                                v-if="item.evaluationCd == ''"
                                :vid="'evaluationName_' + index"
                                label=""
                                v-model="item.evaluationName"
                                :maxLength="40"
                                required
                              />
                              <TextFieldRef v-else label="" :value="item.evaluationName" />
                            </template>
                            <template v-slot:[`item.evaluationResultCd`]="{ item, index }">
                              <SelectSingleInput
                                :vid="'evaluationResultCd_' + index"
                                v-model="item.evaluationResultCd"
                                :items="getEvaluationResultItems(item.isRequired)"
                                itemText="name"
                                itemValue="value"
                                label=""
                                required
                              />
                            </template>
                            <template v-slot:[`item.evaluationReason`]="{ item }">
                              <TextFieldInput
                                v-if="canEditContents"
                                label=""
                                v-model="item.evaluationReason"
                                :maxLength="1000"
                                :required="item.evaluationResultCd == enumMmmmEvaluationResultCd.NA"
                              />
                              <TextFieldRef v-else label="" :value="item.evaluationReason" />
                            </template>
                            <template v-slot:[`item.filePath`]="{ item, index }">
                              <FileInput
                                :vid="'evaluationFilePath_' + index"
                                label=""
                                v-model="item.file"
                                :filePath.sync="item.filePath"
                                :required="item.evaluationResultCd != enumMmmmEvaluationResultCd.NA"
                                :clearable="canEditContents"
                              />
                            </template>
                          </v-data-table>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-form>

          <validation-observer v-slot="{ invalid: excludeEvalInvalid }">
            <v-form :disabled="!canEditContents">
              <v-row>
                <v-col cols="2">
                  <TextFieldInput :label="$t('ELE0481')" v-model="form.initialLotNo" :maxLength="50" />
                </v-col>
                <v-col cols="2">
                  <TextFieldInput :label="$t('ELE0482')" v-model="form.markings" :maxLength="50" />
                </v-col>
              </v-row>
              <v-row v-if="isEpson && alphaUrl != ''">
                <v-col cols="6">
                  <span class="text-h6 d-flex flex-row space-between">
                    Please click this link to view information of ALPHA
                    <BtnLink class="ml-5" label="[Link]" fontSize="20px" @click="onClickAlphaUrl" />
                    <v-spacer />
                  </span>
                </v-col>
              </v-row>

              <br />

              <v-row class="my-0">
                <v-col>
                  <v-card elevation="1" max-width="1200px" outlined>
                    <v-card-title class="py-1">
                      {{ $t('ELE0219') }}
                      <v-spacer />
                      <BtnDelete class="mx-2" :disabled="!canDeleteRoute" @click="onDeleteRoute" />
                      <BtnAdd :disabled="!canAddRoute" @click="onAddRoute" />
                    </v-card-title>
                    <v-card outlined>
                      <v-tabs fixed-tabs v-model="routeTab">
                        <v-tab
                          class="ml-0"
                          v-for="(item, index) in epsonRoutes"
                          :key="item.routeNo"
                          :href="`#${item.routeNo}`"
                        >
                          <span>{{ index + 1 }}</span>
                        </v-tab>
                      </v-tabs>
                      <v-tabs-items v-model="routeTab">
                        <v-tab-item v-for="item in epsonRoutes" :key="item.routeNo" :value="`${item.routeNo}`">
                          <MmmmRequestRouteForm
                            :vid="item.routeNo"
                            :dispositionCd.sync="item.dispositionCd"
                            :dispositionReason.sync="item.dispositionReason"
                            :checkers.sync="item.checkers"
                            isEpsonRoute
                            :companyCd="form.acceptCompanyCd"
                            :companyCatCd="enumCompanyCatCd.EPSON"
                            :currentRouteNo="form.currentRouteNo"
                            :currentRouteDtlNo="form.currentRouteDtlNo"
                            :routeNo="item.routeNo"
                            :reqApproveBy="form.reqAcceptApproval"
                            :disabled="!canEditRoute || item.routeNo < form.currentRouteNo"
                            :dispositionCdItems="createDispositionCdItems(item.routeNo)"
                          />
                        </v-tab-item>
                      </v-tabs-items>
                    </v-card>
                  </v-card>
                </v-col>
              </v-row>
            </v-form>

            <v-row class="my-0" v-if="containsConditionallyAccept">
              <v-form :disabled="!canEditCms">
                <v-col>
                  <v-card class="pb-2" elevation="1" max-width="1200px" outlined>
                    <v-card-title class="py-1">
                      {{ $t('ELE0483') }}
                    </v-card-title>
                    <v-card-text class="py-4">
                      <v-row>
                        <v-col cols="4">
                          <MmmmCmsInput
                            v-model="counterMeasure.cmsCd"
                            :validOnly="canEditCms"
                            :required="isRequiredCmsCd"
                          />
                        </v-col>
                        <v-col cols="6">
                          <TextFieldInput :label="$t('ELE0054')" v-model="counterMeasure.remarks" :maxLength="1000" />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-card max-width="1200" outlined>
                            <v-card-title class="py-0">
                              {{ $t('ELE0485') }}
                            </v-card-title>
                            <v-card-text class="py-4">
                              <v-row>
                                <v-col>
                                  <TextFieldInput
                                    :label="$t('ELE0454')"
                                    v-model="counterMeasure.mcNo"
                                    :maxLength="50"
                                  />
                                </v-col>
                                <v-col>
                                  <TextFieldInput
                                    :label="$t('ELE0455')"
                                    v-model="counterMeasure.mcBrand"
                                    :maxLength="50"
                                  />
                                </v-col>
                                <v-col>
                                  <TextFieldInput
                                    :label="$t('ELE0456')"
                                    v-model="counterMeasure.tonnage"
                                    :maxLength="50"
                                  />
                                </v-col>
                                <v-col>
                                  <SelectSingleInput
                                    v-model="counterMeasure.productTakeOutCd"
                                    :label="$t('ELE0453')"
                                    :items="productTakeOutItems"
                                    itemText="name"
                                    itemValue="value"
                                  />
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col>
                                  <TextFieldInput
                                    :label="$t('ELE0452')"
                                    v-model="counterMeasure.cycleTime"
                                    :maxLength="50"
                                  />
                                </v-col>
                                <v-col>
                                  <TextFieldInput
                                    :label="$t('ELE0461')"
                                    v-model="counterMeasure.partsWeight"
                                    :maxLength="50"
                                  />
                                </v-col>
                                <v-col>
                                  <TextFieldInput
                                    :label="$t('ELE0462')"
                                    v-model="counterMeasure.sprueWeight"
                                    :maxLength="50"
                                  />
                                </v-col>
                                <v-col>
                                  <TextFieldInput
                                    :label="$t('ELE0463')"
                                    v-model="counterMeasure.scrapWeight"
                                    :maxLength="50"
                                  />
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-card max-width="600" outlined>
                            <v-card-title class="py-0">
                              {{ $t('ELE0232') }}
                              <v-spacer />
                              <BtnAdd :disabled="!canEditCms" @click="onAddCmsFile" />
                            </v-card-title>
                            <v-card-text class="py-4">
                              <v-data-table
                                :headers="headersCmsFile"
                                :items="counterMeasure.files"
                                dense
                                disable-pagination
                                hide-default-footer
                                mobile-breakpoint="0"
                              >
                                <template v-slot:[`item.action`]="{ index }">
                                  <IconDelete :disabled="!canEditCms" @click="onDeleteCmsFile(index)" />
                                </template>
                                <template v-slot:[`item.filePath`]="{ item, index }">
                                  <FileInput
                                    :vid="'cmsFilePath_' + index"
                                    label=""
                                    v-model="item.file"
                                    :filePath="item.filePath"
                                    required
                                  />
                                </template>
                              </v-data-table>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-form>
            </v-row>

            <br />

            <v-row v-if="canEditRoute" class="my-0">
              <v-col class="d-flex justify-end">
                <Btn
                  class="mx-4"
                  :label="$t('ELE0247')"
                  :disabled="excludeEvalInvalid || !canTempSave"
                  isCheckRole
                  @click="onClickTempSave"
                />
                <Btn
                  class="mx-4"
                  :label="$t('ELE0215')"
                  :disabled="invalid || !canApprove"
                  isCheckRole
                  @click="onClickApprove"
                />
                <Btn
                  class="mx-4"
                  :label="$t('ELE0249')"
                  :disabled="invalid || !canDeny"
                  isCheckRole
                  @click="onClickDeny"
                />
                <Btn
                  class="mx-4"
                  :label="$t('ELE0250')"
                  :disabled="!canReturnToRequest"
                  isCheckRole
                  @click="onClickReturnToRequest"
                />
                <Btn
                  class="mx-4"
                  :label="$t('ELE0375')"
                  :disabled="!canReturnToSupplier"
                  isCheckRole
                  @click="onClickReturnToSupplier"
                />
              </v-col>
            </v-row>
            <v-row v-else-if="canEditCms" class="my-0">
              <v-col class="d-flex justify-end">
                <Btn class="mx-4" :label="$t('ELE0247')" disabled />
                <Btn
                  class="mx-4"
                  :label="$t('ELE0019')"
                  :disabled="invalid || !canCmsRequest"
                  isCheckRole
                  @click="onClickCmsRequest"
                />
                <Btn class="mx-4" :label="$t('ELE0249')" disabled />
                <Btn class="mx-4" :label="$t('ELE0250')" disabled />
                <Btn class="mx-4" :label="$t('ELE0375')" disabled />
              </v-col>
            </v-row>
          </validation-observer>
        </v-container>
      </v-card-text>
    </v-card>

    <IqcResultDialog
      v-if="iqcResultDialog"
      :dialog.sync="iqcResultDialog"
      :inspIndexNo="inspResult.inspIndexNo"
      :inspCompanyCd="inspResult.inspCompanyCd"
      :lotNo="inspResult.lotNo"
      :partCd="form.partCd"
      :partName="form.partName"
      :inspCat1="inspResult.inspCat1"
      :inspCat2="inspResult.inspCat2"
      :lotDate="inspResult.lotDate"
      inspDataViewOnly
    />
    <UserConfirmDialog
      :dialog="userConfirmDialog"
      :confirmWord="$t('MSG0090')"
      :btnLabel="$t('ELE0019')"
      @cancel="userConfirmDialog = false"
      @proceed="onProceedSave"
    />
  </validation-observer>
</template>

<script>
import { mapGetters } from 'vuex'
import { ValidationObserver } from 'vee-validate'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Loading from '@/mixin/loading-utils.js'
import { Storage } from '@/plugins/storage'
import DateUtil from '@/mixin/date-utils.js'

import {
  Role,
  S3Root,
  MmmmWfCheckedCat,
  MmmmApprovalStatusCd,
  CompanyCatCd,
  OqcIqcCd,
  MmmmEvaluationResultCd,
  MmmmDispositionCd,
  SystemParameterKey,
  InspStatusCd,
  MmmmProductTakeOut,
} from '@/enum'

import TextFieldInput from '@/components/atoms/base/text-field/TextFieldInput'
import TextFieldRef from '@/components/atoms/base/text-field/TextFieldRef'
import Btn from '@/components/atoms/base/button/Btn'
import BtnAdd from '@/components/atoms/button/BtnAdd'
import BtnDelete from '@/components/atoms/button/BtnDelete'
import IconDelete from '@/components/atoms/icon/IconDelete.vue'
import FileInput from '@/components/atoms/file/FileInput'
import SelectSingleInput from '@/components/atoms/base/select/SelectSingleInput'
import BtnLink from '@/components/atoms/base/button/BtnLink'

import MmmmInspIndexInput from '@/components/atoms/select/MmmmInspIndexInput'
import MmmmCmsInput from '@/components/atoms/select/MmmmCmsInput'
import IqcResultDialog from '@/components/organisms/terminal/dialog/ApprovalInspDataListDialog'
import MmmmRequestRouteForm from '@/components/organisms/terminal/form/MmmmRequestRouteForm'
import UserConfirmDialog from '@/components/organisms/common/dialog/ConfirmDialog'

/** 処理モード */
const SaveMode = {
  TEMP_SAVE: 'TEMP_SAVE',
  REQUEST: 'REQUEST',
  APPROVE: 'APPROVE',
  DENY: 'DENY',
  RETURN: 'RETURN',
}

/** SA WFのルートNo */
const RouteNo = {
  EPSON_START: 2,
}

const MaxCountRoute = 10

export default {
  name: 'MmmmRequestEpsonForm',

  mixins: [APIUtils, Message, Loading, DateUtil],

  components: {
    ValidationObserver,
    TextFieldInput,
    TextFieldRef,
    Btn,
    BtnAdd,
    BtnDelete,
    IconDelete,
    FileInput,
    SelectSingleInput,
    BtnLink,
    MmmmInspIndexInput,
    MmmmCmsInput,
    IqcResultDialog,
    MmmmRequestRouteForm,
    UserConfirmDialog,
  },

  props: {
    form: {
      type: Object,
      required: true,
    },
    canEditEpson: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      routeTab: '',
      countAdd: 0,
      headersEvaluation: [
        { text: '', value: 'action', align: 'center', divider: true, sortable: false, width: '50' },
        {
          text: this.$t('ELE0480'),
          value: 'evaluationName',
          divider: true,
          sortable: false,
          cellClass: 'py-1',
          width: '300',
        },
        {
          text: this.$t('ELE0497'),
          value: 'evaluationResultCd',
          divider: true,
          sortable: false,
          cellClass: 'py-1',
          width: '200',
        },
        {
          text: this.$t('ELE0054'),
          value: 'evaluationReason',
          divider: true,
          sortable: false,
          cellClass: 'py-1',
        },
        { text: this.$t('ELE0035'), value: 'filePath', sortable: false, cellClass: 'py-1', width: '300' },
      ],
      headersCmsFile: [
        { text: '', value: 'action', align: 'center', divider: true, sortable: false, width: '50' },
        { text: this.$t('ELE0035'), value: 'filePath', sortable: false, cellClass: 'py-1' },
      ],
      mode: '',
      settings: [
        {
          mode: SaveMode.TEMP_SAVE,
          url: '/mmmm/epson/tempSave',
          canUploadFile: true,
          isValidate: false,
        },
        {
          mode: SaveMode.REQUEST,
          url: '/mmmm/epson/request',
          canUploadFile: true,
          isValidate: true,
        },
        {
          mode: SaveMode.APPROVE,
          url: '/mmmm/epson/approve',
          canUploadFile: false,
          isValidate: true,
        },
        {
          mode: SaveMode.DENY,
          url: '/mmmm/epson/deny',
          canUploadFile: false,
          isValidate: true,
        },
        {
          mode: SaveMode.RETURN,
          url: '/mmmm/epson/return',
          canUploadFile: false,
          isValidate: false,
        },
        {
          mode: SaveMode.RETURN_TO_SUPPLIER,
          url: '/mmmm/epson/returnToSupplier',
          canUploadFile: false,
          isValidate: false,
        },
      ],
      userConfirmDialog: false,
      mcsRegistrationFile: null,
      iqcResultDialog: false,
      inspResult: null,
      alphaUrl: '',
    }
  },

  computed: {
    ...mapGetters(['isEpson']),

    enumCompanyCatCd: () => CompanyCatCd,
    enumOqcIqcCd: () => OqcIqcCd,
    enumMmmmEvaluationResultCd: () => MmmmEvaluationResultCd,
    enumInspStatusCd: () => InspStatusCd,

    productTakeOutItems: {
      get() {
        // プルダウン選択肢をenumから生成
        return Object.values(MmmmProductTakeOut).map((item) => {
          return { name: item + ' : ' + this.$t(`MmmmProductTakeOut.${item}`), value: item }
        })
      },
    },

    canEditEpsonComputed: {
      get() {
        return this.canEditEpson
      },
      set(value) {
        this.$emit('update:canEditEpson', value)
      },
    },
    loginUserCd: {
      get() {
        return this.$store.getters.userCd
      },
    },
    setting: {
      get() {
        return this.settings.find((el) => el.mode === this.mode)
      },
    },
    canDeleteRoute: {
      get() {
        let result = true
        if (!this.canEditRoute || this.routeTab <= this.form.currentRouteNo || this.isFirstRoute(this.routeTab)) {
          result = false
        }
        return result
      },
    },
    canAddRoute: {
      get() {
        let result = true
        if (!this.canEditRoute || this.epsonRoutes.length >= MaxCountRoute) {
          result = false
        }
        return result
      },
    },
    canEditCompany: {
      get() {
        return this.$store.getters.isEpson
      },
    },
    canEditContents: {
      get() {
        return this.canEditCompany && this.form.statusCd == MmmmApprovalStatusCd.SUPPLIER_APPROVED
      },
    },
    canRequest: {
      get() {
        return this.canEditContents
      },
    },
    canEditRoute: {
      get() {
        return this.canRequest || this.canApprove || this.canReturnToRequest
      },
    },
    canApprove: {
      get() {
        let result = false

        if (!this.canEditCompany) {
          result = false
        } else {
          const currentCheckedCat = this.form.currentCheckedCat
          const hasCheck = this.$store.getters.hasRole(Role.MMMM_CHECK)
          const hasApprove = this.$store.getters.hasRole(Role.MMMM_APPROVE)

          if (currentCheckedCat == MmmmWfCheckedCat.REQUEST && (hasCheck || hasApprove)) {
            result = true
          } else if (currentCheckedCat == MmmmWfCheckedCat.CHECK && hasCheck) {
            result = true
          } else if (currentCheckedCat == MmmmWfCheckedCat.APPROVE && hasApprove) {
            result = true
          } else {
            result = false
          }
        }

        return result
      },
    },
    canDeny: {
      get() {
        return this.canApprove
      },
    },
    canReturn: {
      get() {
        const hasCheck = this.$store.getters.hasRole(Role.MMMM_CHECK)
        const hasApprove = this.$store.getters.hasRole(Role.MMMM_APPROVE)
        return this.canEditCompany && (hasCheck || hasApprove)
      },
    },
    canReturnToRequest: {
      get() {
        return this.canReturn && this.form.statusCd == MmmmApprovalStatusCd.EPSON_APPLYING
      },
    },
    canReturnToSupplier: {
      get() {
        return this.canReturn && this.form.statusCd == MmmmApprovalStatusCd.SUPPLIER_APPROVED
      },
    },
    canTempSave: {
      get() {
        return this.canApprove && this.form.statusCd == MmmmApprovalStatusCd.SUPPLIER_APPROVED
      },
    },
    evaluations: {
      get() {
        return this.form.evaluations
      },
    },
    epsonRoutes: {
      get() {
        return this.form.epsonRoutes
      },
      set(value) {
        this.form.epsonRoutes = value
      },
    },
    counterMeasure: {
      get() {
        return this.form.counterMeasure
      },
      set(value) {
        this.form.counterMeasure = value
      },
    },
    isFinalJudgeUser: {
      get() {
        // 最終判定者が操作しているか
        const finalRoute = this.form.epsonRoutes.slice(-1)[0]
        const finalRouteDtl = finalRoute.checkers.slice(-1)[0] // 最終ルート
        return (
          finalRouteDtl.routeNo == this.form.currentRouteNo && finalRouteDtl.routeDtlNo == this.form.currentRouteDtlNo
        )
      },
    },
    userCompanyCd: {
      get() {
        return this.$store.getters.companyCd
      },
    },
    containsConditionallyAccept: {
      get() {
        return this.form.epsonRoutes.some((e) => e.dispositionCd == MmmmDispositionCd.CONDITIONALLY_ACCEPT)
      },
    },
    canEditCms: {
      get() {
        return this.canEditCompany && this.containsConditionallyAccept && (this.canEditContents || this.canCmsRequest)
      },
    },
    canCmsRequest: {
      get() {
        const hasCheck = this.$store.getters.hasRole(Role.MMMM_CHECK)
        const hasApprove = this.$store.getters.hasRole(Role.MMMM_APPROVE)
        return this.form.statusCd == MmmmApprovalStatusCd.APPROVED && (hasCheck || hasApprove)
      },
    },
    isRequiredCmsCd: {
      get() {
        return this.form.statusCd == MmmmApprovalStatusCd.APPROVED || this.hasCmsValue
      },
    },
    hasCmsValue: {
      get() {
        // CounterMeasure項目に1つ以上値を持っているか
        let result = false
        if (this.containsConditionallyAccept) {
          const cms = this.counterMeasure
          const cmsObserveItems = [
            'cmsCd',
            'remarks',
            'cycleTime',
            'productTakeOutCd',
            'mcNo',
            'mcBrand',
            'tonnage',
            'partsWeight',
            'sprueWeight',
            'scrapWeight',
            'files',
          ]

          result = cmsObserveItems.some((e) => {
            let result = false
            if (Array.isArray(cms[e])) {
              if (cms[e].length > 0) {
                result = true
              }
            } else if (cms[e]) {
              result = true
            }
            return result
          })
        }
        return result
      },
    },
  },

  methods: {
    isFirstRoute(routeNo) {
      // 承認ルートの先頭であるか判定
      return routeNo == RouteNo.EPSON_START
    },
    onAddEvaluation() {
      const item = {
        evaluationName: '',
        evaluationCd: '',
        evaluationResultCd: '',
        isRequired: false,
        evaluationReason: '',
        filePath: '',
        file: null,
      }
      this.evaluations.push(item)
    },
    onDeleteEvaluation(index) {
      this.evaluations.splice(index, 1)
    },
    async getEvaluations(applCatCd, partCatCd, reasonDtlCd) {
      try {
        this.evaluations.splice(0, this.evaluations.length)

        let params = {
          applCatCd: applCatCd,
          partCatCd: partCatCd,
          reasonDtlCd: reasonDtlCd,
          validOnly: true,
        }

        const elements = await API.get('/master/mmmm/evaluations', params)
        elements.forEach((element) => {
          const item = {
            evaluationName: element['evaluationName'],
            evaluationCd: element['evaluationCd'],
            isRequired: element['isRequired'],
            evaluationResultCd: '',
            evaluationReason: '',
            filePath: '',
            file: null,
          }
          this.evaluations.push(item)
        })
      } catch (error) {
        this.evaluations.splice(0, this.evaluations.length)
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0480') })))
      }
    },
    getEvaluationResultItems(isRequiredResultCd) {
      let items = []
      let item = null

      item = MmmmEvaluationResultCd.OK
      items.push({ name: item + ' : ' + this.$t(`MmmmEvaluationResultCd.${item}`), value: item })

      if (!isRequiredResultCd) {
        item = MmmmEvaluationResultCd.NA
        items.push({ name: item + ' : ' + this.$t(`MmmmEvaluationResultCd.${item}`), value: item })
      }

      item = MmmmEvaluationResultCd.NG
      items.push({ name: item + ' : ' + this.$t(`MmmmEvaluationResultCd.${item}`), value: item })

      return items
    },
    async onAddRoute() {
      this.countAdd++

      const item = {
        routeNo: this.countAdd + MaxCountRoute,
        dispositionCd: '',
        dispositionReason: '',
        checkers: [
          {
            checkerCd: '',
            checkedDatetime: '',
            remarks: '',
            checkedCat: MmmmWfCheckedCat.REQUEST,
          },
          {
            checkerCd: '',
            checkedDatetime: '',
            remarks: '',
            checkedCat: MmmmWfCheckedCat.CHECK,
          },
          {
            checkerCd: '',
            checkedDatetime: '',
            remarks: '',
            checkedCat: MmmmWfCheckedCat.APPROVE,
          },
        ],
      }
      this.epsonRoutes.splice(this.epsonRoutes.length + 1, 0, item)
      await this.refreshTab(this.routeTab)
    },
    onDeleteRoute() {
      this.epsonRoutes = this.epsonRoutes.filter((m) => m.routeNo != this.routeTab)
    },
    onAddCmsFile() {
      const item = {
        filePath: '',
        file: null,
      }
      this.counterMeasure.files.push(item)
    },
    onDeleteCmsFile(index) {
      this.counterMeasure.files.splice(index, 1)
    },
    onClickApprove() {
      // 承認
      if (this.canRequest) {
        this.mode = SaveMode.REQUEST
      } else {
        this.mode = SaveMode.APPROVE
      }
      this._save()
    },
    onClickDeny() {
      // 否認
      this.mode = SaveMode.DENY
      this._save()
    },
    onClickReturnToRequest() {
      // 申請者へ戻す
      this.mode = SaveMode.RETURN
      this._save()
    },
    onClickReturnToSupplier() {
      // サプライヤーへ戻す
      this.mode = SaveMode.RETURN_TO_SUPPLIER
      this._save()
    },
    async onClickTempSave() {
      // 一時保存
      this.mode = SaveMode.TEMP_SAVE
      await this._save()
    },
    async onProceedSave() {
      // 保存を進める
      this.userConfirmDialog = false
      let checker = this.getCurrentChecker()
      checker.checkerCd = this.loginUserCd
      await this._save()
    },
    onClickCmsRequest() {
      this._saveCms()
    },
    async _save() {
      // 保存
      try {
        this.startLoading()

        if (this.setting.isValidate && !(await this.validate())) {
          return
        }

        if (this.setting.canUploadFile) {
          await this.uploadMcsRegistrationFile()
          await this.uploadEvaluations()
          if (this.hasCmsValue) await this.uploadCms()
        }
        const body = {
          mmmmNo: this.form.mmmmNo,
          wfNo: this.form.wfNo,
          wfVersionNo: this.form.wfVersionNo,
          currentRouteNo: this.form.currentRouteNo,
          currentRouteDtlNo: this.form.currentRouteDtlNo,
          acceptCompanyCd: this.form.acceptCompanyCd,
          remarks: this.form.remarks,
          plPr: this.form.plPr,
          iqcInspIndexNo: this.form.iqcInspIndexNo,
          evaluations: this.form.evaluations,
          initialLotNo: this.form.initialLotNo,
          markings: this.form.markings,
          epsonRoutes: this.epsonRoutes,
          counterMeasure: this.hasCmsValue ? this.counterMeasure : null,
          requestComment: this.getCurrentChecker().remarks,
        }

        await API.post(this.setting.url, body)
        this.setSuccessMessage(this.$t('MSG0011', { p0: this.form.mmmmNo }))
        this.resetForm()
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0003', { p0: this.$t('ELE0491') })))
      } finally {
        this.stopLoading()
      }
    },
    async _saveCms() {
      // Approved後のCounterMeasure保存
      try {
        this.startLoading()

        if (!(await this.$refs.observer.validate())) {
          return false
        }

        await this.uploadCms()

        const body = {
          mmmmNo: this.form.mmmmNo,
          wfNo: this.form.wfNo,
          wfVersionNo: this.form.wfVersionNo,
          counterMeasure: this.counterMeasure,
        }

        await API.post('/mmmm/epson/cms/request', body)
        this.setSuccessMessage(this.$t('MSG0011', { p0: this.form.mmmmNo }))
        this.resetForm()
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0003', { p0: this.$t('ELE0491') })))
      } finally {
        this.stopLoading()
      }
    },
    async uploadMcsRegistrationFile() {
      // mcsRegistrationFileをS3へアップロード
      if (this.mcsRegistrationFile && this.form.plPr.mcsRegistrationFilePath == '') {
        this.form.plPr.mcsRegistrationFilePath = await Storage.uploadFile(
          this.mcsRegistrationFile,
          'mmmm/' + this.form.mmmmNo + '/' + S3Root.MMMM_MCS,
        )
        this.mcsRegistrationFile = null
      }
    },
    async uploadEvaluations() {
      // 評価ファイルをS3へアップロード
      for (let idx = 0; idx < this.evaluations.length; idx++) {
        if (this.evaluations[idx].file && this.evaluations[idx].filePath == '') {
          this.evaluations[idx].filePath = await Storage.uploadFile(
            this.evaluations[idx].file,
            'mmmm/' + this.form.mmmmNo + '/' + S3Root.MMMM_EVALUATION,
          )
          this.evaluations[idx].file = null
        }
      }
    },
    async uploadCms() {
      // 対策ファイルをS3へアップロード
      for (let idx = 0; idx < this.counterMeasure.files.length; idx++) {
        if (this.counterMeasure.files[idx].file && this.counterMeasure.files[idx].filePath == '') {
          this.counterMeasure.files[idx].filePath = await Storage.uploadFile(
            this.counterMeasure.files[idx].file,
            'mmmm/' + this.form.mmmmNo + '/' + S3Root.MMMM_CMS,
          )
          this.counterMeasure.files[idx].file = null
        }
      }
    },
    async validate() {
      // 入力チェック
      if (!(await this.$refs.observer.validate())) {
        return false
      }

      // 条件付き合格を含む場合、2ルート以上で承認する
      if (this.containsConditionallyAccept && this.epsonRoutes.length <= 1) {
        this.setErrorMessage(this.$t('MSG0153'))
        return false
      }

      if (this.existsUserInRoute()) {
        this.setErrorMessage(this.$t('MSG0094'))
        return false
      }

      const checker = this.getCurrentChecker()
      if (checker && checker.checkerCd != this.loginUserCd) {
        this.userConfirmDialog = true
        return false
      }

      return true
    },
    getCurrentRoute() {
      // 現在の処理ルート取得
      return this.form.epsonRoutes.find((el) => el.routeNo == this.form.currentRouteNo)
    },
    existsUserInRoute() {
      // 現在ルート詳細No以外で、ログインユーザーが指定されているかチェック
      return this.getCurrentRoute().checkers.some(
        (el) => el.routeDtlNo != this.form.currentRouteDtlNo && el.checkerCd == this.loginUserCd,
      )
    },
    getCurrentChecker() {
      // WFで指定されている現在の処理ユーザー取得
      return this.getCurrentRoute().checkers.find((el) => el.routeDtlNo == this.form.currentRouteDtlNo)
    },
    resetForm() {
      if (this.mode == SaveMode.TEMP_SAVE) {
        this.$emit('research', this.form.mmmmNo)
      } else {
        this.$emit('reset')
      }
    },
    async refreshTab(tabNo) {
      // 全タブのvee-validateを走らせるために、全タブを1度activeにする。
      for (let idx = 0; idx < this.epsonRoutes.length; idx++) {
        this.routeTab = String(this.epsonRoutes[idx].routeNo)
        await this.$nextTick()
      }
      this.routeTab = String(tabNo)
    },
    async setAlphaUrl() {
      try {
        let url = ''

        const param = await API.get(`/master/systemParameter/${SystemParameterKey.ALPHA_URL}`)
        if (param) {
          url = param.value
          url = url.replace('{mmmmNo}', this.form.mmmmNo)
          url = url.replace('{applCatCd}', this.form.applCatCd)
        }
        this.alphaUrl = url
      } catch (error) {
        if (error.response.status != 404) {
          this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0348') })))
        }
      }
    },
    onClickAlphaUrl() {
      window.open(this.alphaUrl, '_blank')
    },
    createDispositionCdItems(routeNo) {
      let items = []
      // プルダウン選択肢をenumから生成
      items = Object.values(MmmmDispositionCd).map((item) => {
        return { name: item + ' : ' + this.$t(`MmmmDispositionCd.${item}`), value: item }
      })
      if (!this.isFirstRoute(routeNo)) {
        // 先頭ルート以外では、CONDITIONALLY_ACCEPT削除
        items.some(function (v, i) {
          if (v.value == MmmmDispositionCd.CONDITIONALLY_ACCEPT) items.splice(i, 1)
        })
      }
      return items
    },
    async showInspResult() {
      try {
        this.inspResult = null

        this.startLoading()
        const element = await API.get(`/inspIndex/inspIndexes/${this.form.iqcInspIndexNo}`)
        this.inspResult = {
          inspIndexNo: element.inspIndexNo,
          inspCompanyCd: element.inspCompanyCd,
          lotNo: element.lotNo,
          inspCat1: element.inspCat1,
          inspCat2: element.inspCat2,
          lotDate: this.toLocalDate(element.inspCreateDatetime),
        }
        this.iqcResultDialog = true
      } catch (error) {
        this.iqcResultDialog = false
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0118') })))
      } finally {
        this.stopLoading()
      }
    },
  },
  async mounted() {
    try {
      this.startLoading()
      if (this.canEditContents && this.evaluations.length == 0) {
        await this.getEvaluations(this.form.applCatCd, this.form.partCatCd, this.form.reasonDtlCd)
      }

      await this.setAlphaUrl()
    } finally {
      this.stopLoading()
    }

    await this.refreshTab(this.form.currentRouteNo)
    this.canEditEpsonComputed = this.canEditRoute
  },
}
</script>

<style scoped>
.form-mmmm-epson .row > .col {
  padding: 8px;
}
</style>
